import React, { useState } from 'react';
import Map from './Map';
import type { Campsite, NormalizedDogWalk } from './types';
import './styles/main.css';
import 'leaflet/dist/leaflet.css';

type POI = {
  name: string;
  description: string;
  latitude: number;
  longitude: number;
};

function App() {
  const [selectedCoords, setSelectedCoords] = useState<{ latitude: number; longitude: number } | null>(null);
  const [pois, setPOIs] = useState<POI[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [campsiteMarkers, setCampsiteMarkers] = useState<(Campsite | NormalizedDogWalk)[]>([]);

  const handleAddPOI = (poi: POI) => {
    if (editingIndex !== null) {
      setPOIs(prev => prev.map((p, i) => (i === editingIndex ? poi : p)));
      setEditingIndex(null);
    } else {
      setPOIs(prev => [...prev, poi]);
    }
  };

  const handleEditPOI = (index: number) => {
    setEditingIndex(index);
    const poi = pois[index];
    setSelectedCoords({ latitude: poi.latitude, longitude: poi.longitude });
  };

  const fetchNearbySites = async (lat: number, lng: number) => {
    try {
      const response = await fetch("/api/places", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lat: lat, lon: lng, radius: 25 }),
      });
      const data = await response.json();
      setCampsiteMarkers(data);
    } catch (error) {
      console.error('Error fetching nearby sites:', error);
    }
  };

  return (
    <div className="app">
      <Map
        onMapClick={setSelectedCoords}
        pois={pois}
        onMarkerClick={handleEditPOI}
        markers={campsiteMarkers}
        fetchNearbySites={fetchNearbySites}
      />
    </div>
  );
}

export default App;